import { render } from "./OrderDetailsStatus.vue?vue&type=template&id=d2fd2ec6&scoped=true"
import script from "./OrderDetailsStatus.vue?vue&type=script&lang=js"
export * from "./OrderDetailsStatus.vue?vue&type=script&lang=js"

import "./OrderDetailsStatus.vue?vue&type=style&index=0&id=d2fd2ec6&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2fd2ec6"]])

export default __exports__